import './main.scss';
import primevueComponents from './plugins/primevue';
import menuItems from './main-menu';
import router from './plugins/router';

//Import admin/précon/shared plugins
import colorsPlugin from '@precon-tools-suite-by-shared/shared-colors-ui';
import receivers from '@precon-tools-suite-by-shared/primevue-receivers';
import fieldsPlugin from '@precon-tools-suite-by-shared/shared-common-forms-ui';
import { createFreyaApp } from '@precon-tools-suite-by-shared/shared-layout-freya-ui';
import toastsPlugin from '@precon-tools-suite-by-shared/shared-common-toasts-ui';
import theme from '@precon-tools-suite-by-shared/ui-theme/freya-precon-food-management';
import adminAccesControlFeaturePlugin from '@precon-tools-suite-by-shared/admin-access-control-feature';
import adminCompaniesFeaturePlugin from '@precon-tools-suite-by-shared/admin-companies-feature';
import vueBackendClientPlugin from '@precon-tools-suite-by-shared/shared-backend-client-vue';
import preconAuthenticationPlugin from '@precon-tools-suite-by-shared/shared-auth-feature';
import adminMaintenanceFeaturePlugin from '@precon-tools-suite-by-shared/admin-maintenance-feature';
import preconDataNodesPlugin from '@precon-tools-suite-by-shared/shared-data-nodes-feature';

const app = createFreyaApp({
    theme,
    menuItems,
    hideSidebarTimeout: 100,
    rightBarPartials: [],
});

app.use(primevueComponents);
app.use(colorsPlugin);
app.use(receivers);

app.use(vueBackendClientPlugin, {
    scopes: {
        PreconBackend: ['Gino.CurrentTeam.Products.Read'],
    },
    router,
    appName: __APP_NAME__,
    appVersion: __APP_VERSION__,
    connectToDevTools: import.meta.env.DEV,
    logGraphQLErrors: import.meta.env.DEV,
    logGraphQLRoundTrip: import.meta.env.DEV,
    logMsalEvents: import.meta.env.DEV,
});

app.use(toastsPlugin);
app.use(preconAuthenticationPlugin, {
    fetchRolesFromBackendIfMissingInToken: true,
    router,
    authenticatedRoute: { name: 'access-restricted' },
});
app.use(preconDataNodesPlugin);

app.use(fieldsPlugin);

app.use(adminAccesControlFeaturePlugin);
app.use(adminCompaniesFeaturePlugin);
app.use(adminMaintenanceFeaturePlugin);

app.use(router);

// Start the application.
app.mount('#app');
